import React from 'react';
import Box from '@material-ui/core/Box';
import moment from 'moment';

function BasicInformationField(props) {
  return (

    <Box fontWeight='fontWeightLight' m={ 1 }>
      {props.title}
      {' '}
      :
      {moment(`${ props.field }`).format(' h:mm a MMMM DD, YYYY')}
    </Box>
  );
}

export default BasicInformationField;
